module.exports = __webpack_public_path__ + "static/media/iso.0784c274.png";